const MAX_DIM = 1600;
const JPEG_QUALITY = 0.82;

export async function compressImageFile(file: File, maxDim = MAX_DIM, quality = JPEG_QUALITY): Promise<File> {
  if (!file.type.startsWith("image/")) return file;
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, maxDim / Math.max(bitmap.width, bitmap.height));
  const width = Math.max(1, Math.round(bitmap.width * scale));
  const height = Math.max(1, Math.round(bitmap.height * scale));
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  if (!ctx) return file;
  ctx.drawImage(bitmap, 0, 0, width, height);
  bitmap.close();
  const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/jpeg", quality));
  if (!blob) return file;
  const name = file.name.replace(/\.[^.]+$/, "") || "capture";
  return new File([blob], `${name}.jpg`, { type: "image/jpeg" });
}

export async function canvasToJpegFile(canvas: HTMLCanvasElement, name = "capture.jpg"): Promise<File> {
  const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/jpeg", JPEG_QUALITY));
  if (!blob) throw new Error("Could not capture image");
  return new File([blob], name, { type: "image/jpeg" });
}
